module.exports = __webpack_public_path__ + "img/IOT.2493e6af.webp";